import request from '@/request'
import handler from '@/utils/responseHandler'

export default {
  /**
   * 生成朋友圈分享二维码水印
   */
  '331201': (data = {}) => {
    data.pid = 331201

    return request.ticket({
      url: '/gateway/gtgj/qp',
      data,
      sidFields: ['uid', 'pid']
    }).then(handler.resBdData)
  },

  /**
   * 生成小程序码
   * 文档链接： https://git.133ec.com/gtgjx/gtgjxdoc/blob/master/act/applet/%E5%B0%8F%E7%A8%8B%E5%BA%8F%E7%A0%81%E6%8E%A5%E5%8F%A3.md
   * pageUrl, pageParams, lineColor, width, extendid, withBase64
   */
  '331608': (opts = {}) => {
    return request.ticket({
      url: '/gateway/gtgj/act',
      sidFields: ['uid', 'pid'],
      data: {
        pid: 331608,
        ...opts
      }
    }).then(handler.resBdData)
  }
}



// WEBPACK FOOTER //
// ./src/api/miniProgramQrCode.js